export default __webpack_public_path__ + "static/media/rm2.1062d4f3.png";